export const DEFAULT_EXTRA_CENTS_KEY = 'default_extra_cents';
export const MARGIN_THRESHOLD_KEY = 'drink.marginThresholdPercent';
export const POINTS_PER_EUR_KEY = 'pos.pointsPerEur';
